module.exports = __webpack_public_path__ + "img/76236.ce49bcab.svg";